import { render, staticRenderFns } from "./otelrezervasyonfisi.vue?vue&type=template&id=b586695a&"
import script from "./otelrezervasyonfisi.vue?vue&type=script&lang=js&"
export * from "./otelrezervasyonfisi.vue?vue&type=script&lang=js&"
import style0 from "./otelrezervasyonfisi.vue?vue&type=style&index=0&id=b586695a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports